module.exports = __webpack_public_path__ + "static/1seater_4k-8d2c681fcdde3cb2f0bc75cbfb4b5980.webp";